import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Slide from "Components/Slide";

export default class SlidePreview extends React.Component
{
    state = {
        anchorEl: null
    };

    static propTypes = {
        slide: PropTypes.object.isRequired,
        active: PropTypes.bool,
        scale: PropTypes.number,
    };

    static defaultProps = {
        active: false,
        scale: 0.15
    };

    openControls = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    closeControls = () => {
        this.setState({ anchorEl: null });
    };

    render()
    {
        const classes = {
            preview: classNames(
                "overflow-hidden select-none",
                "relative rounded flex justify-center align-middle items-center",
                "border bg-white text-xl group-hover:shadow group-hover:border-indigo-600",
                {
                    "shadow border-indigo-600 bg-indigo-600 text-white": this.props.active,
                }
            )
        };

        return <div className={classes.preview} style={{width: 400 * this.props.scale, height: 600 * this.props.scale}}>
            <div style={{transform: `scale(${this.props.scale})`, lineHeight: 'initial'}}>
                <Slide slide={this.props.slide} />
            </div>
        </div>;
    }
}
